const TEAM = [
  { name: 'Jagan', role: 'Founder & CEO', photo: '/team/jagan.jpeg' },
  { name: 'Rohit Thakur', role: 'Creative Head', photo: '/team/rohit.jpeg' },
  { name: 'Chandrika', role: 'Creative Director', photo: '/team/chandrika.jpeg' },
  { name: 'Vidyadhar', role: 'Head of AI & Technology', photo: '/team/vidyadhar.jpeg' },
];

export default function TeamSection() {
  return (
    <section className="bg-black py-20 sm:py-28 border-t border-white/[0.08] w-full">
      <div className="w-full px-5 sm:px-10 lg:px-16 xl:px-24">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 pb-10 border-b border-white/[0.08]">
          <div>
            <p className="text-[11px] uppercase tracking-[0.14em] text-[#767d88] mb-2">
              Leadership
            </p>
            <h2 className="text-white font-normal tracking-[-0.03em] leading-[1.05] text-[clamp(1.85rem,3.4vw,3.25rem)]">
              Built by filmmakers, powered by AI.
            </h2>
          </div>
          <p className="text-[#767d88] text-sm sm:text-[15px] max-w-md">
            Filmmakers, VFX supervisors, and AI engineers delivering across the US, UK,
            Middle East, Europe, and India.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 pt-10">
          {TEAM.map((m) => (
            <div key={m.name} className="group">
              <div className="aspect-[4/5] rounded-lg overflow-hidden bg-[#111113] border border-white/[0.08] mb-3.5">
                <img
                  src={m.photo}
                  alt={`${m.name}, ${m.role} at MotionX Studios`}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                />
              </div>
              <h3 className="text-[17px] font-medium tracking-[-0.02em] text-white">
                {m.name}
              </h3>
              <p className="text-[13px] text-[#767d88] mt-0.5">{m.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
